/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLinkMinus: {
  name: 'link-minus';
  data: string;
} = {
  name: 'link-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.793 5.207a3.95 3.95 0 0 0-5.586 0l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a5.95 5.95 0 1 1 8.414 8.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a3.95 3.95 0 0 0 0-5.586ZM6.707 10.293a1 1 0 0 1 0 1.414l-1.5 1.5a3.95 3.95 0 0 0 5.586 5.586l1.5-1.5a1 1 0 1 1 1.414 1.414l-1.5 1.5a5.95 5.95 0 0 1-8.414-8.414l1.5-1.5a1 1 0 0 1 1.414 0ZM10 11a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2h-4Z" fill="currentColor"/></svg>`,
};
